export default __webpack_public_path__ + "static/media/white-plus-black-bg.ca7ce548.svg";